import { marked } from 'marked'

// Tags potencialmente perigosas removidas do HTML gerado pelo Markdown.
const TAGS_PROIBIDAS = ['script', 'style', 'iframe', 'object', 'embed', 'form', 'link', 'meta', 'base']

/**
 * Sanitiza o HTML gerado pelo Markdown, removendo tags e atributos perigosos.
 * Defesa contra XSS em conteúdo gerado por IA (prompt injection).
 */
const sanitizarContainer = (container) => {
  TAGS_PROIBIDAS.forEach((tag) => {
    container.querySelectorAll(tag).forEach((el) => el.remove())
  })

  container.querySelectorAll('*').forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      const nome = attr.name.toLowerCase()
      const valor = (attr.value || '').trim().toLowerCase()
      if (nome.startsWith('on')) {
        el.removeAttribute(attr.name)
      } else if ((nome === 'href' || nome === 'src') && valor.startsWith('javascript:')) {
        el.removeAttribute(attr.name)
      }
    })
  })

  return container
}

/**
 * Converte #hashtags em links clicáveis APENAS em nós de texto,
 * evitando corromper atributos/URLs do HTML.
 */
const aplicarHashtags = (container) => {
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT)
  const textNodes = []
  let node
  while ((node = walker.nextNode())) textNodes.push(node)

  textNodes.forEach((textNode) => {
    const valor = textNode.nodeValue
    if (!valor || !/#\w{2,50}/.test(valor)) return

    const escapado = valor
      .replace(/&/g, '&')
      .replace(/</g, '<')
      .replace(/>/g, '>')

    const span = document.createElement('span')
    span.innerHTML = escapado.replace(/#(\w{2,50})/g, '<a href="#" class="hashtag-link" data-hashtag="$1">#$1</a>')
    textNode.parentNode.replaceChild(span, textNode)
  })
}

/**
 * Renderiza Markdown de forma segura (sanitizado).
 * @param {string} texto - Markdown de entrada.
 * @param {{ hashtags?: boolean }} opcoes - Se true, converte #hashtags em links clicáveis.
 * @returns {string} HTML sanitizado.
 */
export const renderizarMarkdown = (texto, { hashtags = false } = {}) => {
  if (!texto) return ''
  try {
    const container = document.createElement('div')
    container.innerHTML = marked.parse(texto)
    sanitizarContainer(container)
    if (hashtags) aplicarHashtags(container)
    return container.innerHTML
  } catch {
    return texto
  }
}
